import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Fade from "@mui/material/Fade";
import { Outlet } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Button from "@mui/material/Button";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkIcon from "@mui/icons-material/Link";
import ShareIcon from "@mui/icons-material/Share";
import BusinessIcon from "@mui/icons-material/Business";
import DrawIcon from "@mui/icons-material/Draw";
import { Backdrop, CircularProgress, Grid2, ListItemIcon, Stack, Typography } from "@mui/material";
import Carrousel from "../patrocinadores/Carrousel";
import ListaSponsor from "../patrocinadores/ListaSponsor";

const live_events_service = require('../../helpers/live_events_service')

function ScrollTop(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
      >
        {children}
      </Box>
    </Fade>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};
const drawerWidth = 240;

export default function Layout(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [loading, setLoading] = useState(true);
  const [contador] = useState(0);
  const [navItems, setNavItems] = useState([{ id: 0, label: "Inicio", href: "/", target: "_self" },
  {
    id: 1,
    label: "Patrocinio",
    href: '/patrocinio',
    target: "_self",
  },
  {
    id: 2,
    label: "Tarifas",
    href: "/tarifas",
    target: "_self",
  },
  {
    id: 3,
    label: "Programa",
    href: "/programa",
    target: "_self",
  },])
  const [patrocinadores, setPatrocinadores] = useState([])
  useEffect(() => {
    live_events_service.getData('/patrocinador/view-by-evento/' + process.env.REACT_APP_EVT).then((response_patrocinadores) => {
      setPatrocinadores(response_patrocinadores.data.response.result)
      setLoading(false)
    }).catch((error) => {
      console.log(error)
    })

  }, [contador])
  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };
  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <List>
        {navItems.map((item) => (
          <ListItem key={item.id} disablePadding>
            <ListItemButton
              sx={{ textAlign: "center" }}
              href={item.href}
              target={item.target}
            >
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;
  return (
    <React.Fragment>
      <CssBaseline />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <AppBar
        component="nav"
        style={{ backgroundColor: "#032E1E" }}
        sx={{ placeItems: { xs: "left", md: "center", lg: "center" } }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            {navItems.map((item) => (
              <Button
                key={item.id}
                sx={{ color: "#fff" }}
                href={item.href}
                target={item.target}
              >
                {item.label}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
      <Box component="main">
        <Toolbar id="back-to-top-anchor" />

        <Box
          style={{ width: '100%' }}
        >
          <img src='https://escuela-bancaria.s3.us-east-2.amazonaws.com/f2a35c7d-9ad1-4b2b-8d76-a7fbbd1b83b2.jpeg' style={{ width: '100%' }} />
        </Box>
        <Carrousel patrocinadores={patrocinadores} />
        <Outlet />
        <ListaSponsor patrocinadores={patrocinadores} />
        <Grid2 container>
          <Grid2 size={{ xs: 12, md: 6, lg: 3 }} p={2}>
            <Stack spacing={5} style={{ textAlign: "center" }}>
              <Typography variant="h5" style={{ color: "#2B6855" }}>
                <ShareIcon />
                &nbsp;&nbsp;&nbsp;Redes Sociales
              </Typography>
              <List>
                <ListItem disablePadding style={{ textAlign: "center" }}>
                  <ListItemButton
                    style={{ color: "#2B6855", textAlign: "center" }}
                    href="https://www.linkedin.com/in/escuela-bancaria-de-guatemala-b0286b9b/"
                    target="_blank"
                  >
                    <ListItemIcon
                      style={{ color: "#2B6855", textAlign: "center" }}
                    >
                      <LinkedInIcon />
                    </ListItemIcon>
                    <ListItemText primary="LinkedIn" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding style={{ textAlign: "center" }}>
                  <ListItemButton
                    target="_blank"
                    href="https://www.facebook.com/abg.ebg"
                    style={{ color: "#2B6855", textAlign: "center" }}
                  >
                    <ListItemIcon
                      style={{ color: "#2B6855", textAlign: "center" }}
                    >
                      <FacebookIcon />
                    </ListItemIcon>
                    <ListItemText primary="Facebook" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding style={{ textAlign: "center" }}>
                  <ListItemButton
                    target="_blank"
                    href="https://twitter.com/ABG_EBG"
                    style={{ color: "#2B6855", textAlign: "center" }}
                  >
                    <ListItemIcon
                      style={{ color: "#2B6855", textAlign: "center" }}
                    >
                      <XIcon />
                    </ListItemIcon>
                    <ListItemText primary="X" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding style={{ textAlign: "center" }}>
                  <ListItemButton
                    target="_blank"
                    href="https://www.instagram.com/ebg.guatemala/?hl=es-la"
                    style={{ color: "#2B6855", textAlign: "center" }}
                  >
                    <ListItemIcon
                      style={{ color: "#2B6855", textAlign: "center" }}
                    >
                      <InstagramIcon />
                    </ListItemIcon>
                    <ListItemText primary="Instagram" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding style={{ textAlign: "center" }}>
                  <ListItemButton
                    target="_blank"
                    href="https://www.youtube.com/@escuelabancariadeguatemala4771"
                    style={{ color: "#2B6855", textAlign: "center" }}
                  >
                    <ListItemIcon
                      style={{ color: "#2B6855", textAlign: "center" }}
                    >
                      <YouTubeIcon />
                    </ListItemIcon>
                    <ListItemText primary="YouTube" />
                  </ListItemButton>
                </ListItem>
              </List>
            </Stack>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, lg: 3 }} p={2}>
            <Stack spacing={5} style={{ textAlign: "center" }}>
              <Typography variant="h5" style={{ color: "#2B6855" }}>
                <LinkIcon />
                &nbsp;&nbsp;&nbsp;Otros enlaces
              </Typography>
              <List>
                <ListItem disablePadding style={{ textAlign: "center" }}>
                  <ListItemButton
                    target="_blank"
                    href="https://abg.org.gt/"
                    style={{ color: "#2B6855", textAlign: "center" }}
                  >
                    <ListItemText primary="Asociación Bancaria de Guatemala" />
                  </ListItemButton>
                </ListItem>
              </List>
            </Stack>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, lg: 3 }} p={2}>
            <Stack spacing={1} style={{ textAlign: "center" }}>
              <Typography variant="h5" style={{ color: "#2B6855" }}>
                <BusinessIcon />
                &nbsp;&nbsp;&nbsp;Organiza
              </Typography>
              <img
                alt="img"
                src="https://escuela-bancaria.s3.us-east-2.amazonaws.com/logo+ABG+azul.png"
                style={{ width: "100%" }}
              />
            </Stack>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, lg: 3 }} p={2}>
            <Stack
              spacing={5}
              style={{ textAlign: "center" }}
              alignItems="center"
            >
              <Typography variant="h5" style={{ color: "#2B6855" }}>
                <DrawIcon />
                &nbsp;&nbsp;&nbsp;Regístrate
              </Typography>
              <img
                alt="img"
                src="https://escuela-bancaria.s3.us-east-2.amazonaws.com/d896de27-70b5-4edb-b0d8-7116169ee24f.png"
                style={{ width: "50%" }}
              />
              <List>
                <ListItem disablePadding style={{ textAlign: "center" }}>
                  <ListItemButton
                    style={{ color: "#2B6855", textAlign: "center" }}
                    href="https://ebg.edu.gt/inscripcion/4e3151eb-4bd9-405b-8b4e-f5acc5371a25"
                    target="_blank"
                  >
                    {" "}
                    <ListItemIcon
                      style={{ color: "#2B6855", textAlign: "center" }}
                    >
                      <DrawIcon />
                    </ListItemIcon>
                    <ListItemText primary="Registro a COREFIS" />
                  </ListItemButton>
                </ListItem>
              </List>
            </Stack>
          </Grid2>
        </Grid2>
      </Box>
      <ScrollTop {...props}>
        <Stack spacing={3}>
          <Button
            target="_blank"
            style={{
              color: '#032E1E',
              padding: '12px 24px',  // Hacerlo un poco más grande
              position: 'relative',
              overflow: 'hidden',
              border: '2px solid #032E1E',  // Añadir un borde para resaltar la animación
              animation: 'pixelate 0.5s infinite alternate'
            }}
            startIcon={<DrawIcon />}
            href={'https://ebg.edu.gt/inscripcion/' + process.env.REACT_APP_EVT}
          >
            Regístrate
          </Button>


          <Fab size="small" aria-label="scroll back to top">

            <KeyboardArrowUpIcon />
          </Fab>
        </Stack>

      </ScrollTop>
    </React.Fragment>
  );
}
